module.exports = __webpack_public_path__ + "img/icon-math-title.47f4af77.png";